import type { TicketRedeemedSocketEvent } from "./ticket-redeemed.socket-event";
import type { TicketRevertedSocketEvent } from "./ticket-reverted.socket-event";
import type { TicketScannedSocketEvent } from "./ticket-scanned.socket-event";
import {
    ticketSocketEventNamespace,
    ticketSocketEventTypeNames,
} from "./ticket-socket-event-type-name";

type TicketSocketEvent =
    | TicketRedeemedSocketEvent
    | TicketRevertedSocketEvent
    | TicketScannedSocketEvent;

type TicketSocketEventType = TicketSocketEvent["type"];

const ticketSocketEventTypes = ticketSocketEventTypeNames.map(
    name => `${ticketSocketEventNamespace}:${name}`,
) as TicketSocketEventType[];

export { ticketSocketEventTypes };
export type { TicketSocketEvent, TicketSocketEventType };
